/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
*/

// IP-NOTICE: MIXED
export const environment = {
  production: true,
  // TODO: changed to http for initial sprint. Needs to be https once SSL in place
  baseUrl: 'https://orbit-test-api.kaleidaext.co.uk', // placeholder for replacement on deployment by the actual api url for the target environment
  apiPrefix: '/api',
  clientSecret: 'aaaaaaaa-dfb2-4cf8-8151-d85b41cd7be1',
  buildLabel: '2026.05.12.2605',
  notificationHubUrl: 'http://thisisthehubstub.co.uk', // placeholder for replacement on deployment by the actual url for the target environment
  ticketShopUrl: 'https://orbittickets-shop-test-spa-bgeqhgg0fbe2bsdd.uksouth-01.azurewebsites.net', // placeholder for replacement on deployment by the actual url for the target environment
  baseUrlForRaisingDefect: 'http://thisisthedefectraisingapistub.co.uk',
  apiPrefixForRaisingDefect: '/api',
  projectKeyForRaisingDefect: '' ,
  name: 'TEST',
  tinyMceApiKey: 'ey608wvcvuc71ndbwojkfvuttigst7o428fhlknq9bwbrog6', //'ey608wvcvuc71ndbwojkfvuttigst7o428fhlknq9bwbrog6',
  googleRecaptchaSiteKey: '6LcSkFYrAAAAAIIktFOJaVhbmC6oTvUrxnuHApju',   // V2
  //googleRecaptchaSiteKey: '6LdRfVYrAAAAADCW6jWwriqeRVIJmYFFhZNnwmlO', // V3
  microsoftGraphApplicationId: '31dd1da0-4683-4c5e-9b9b-a49ea39f70dd',
  microsoftGraphTenantId: '3586e670-a521-445f-8af9-f25733ad00a3',
  uiBlockerTimeout: 30000,
  allowSystemMenu: false,
  allowSandboxMenu: true,
  ryftPublicKey: 'pk_sandbox_jt8Gvo2Yz4vPHGQx5cJRNrkO93DYBFGsO9LzvEC3LKLjqD9wILpeT/SOPvMIK3DE', 
  ryftMerchantName: 'Kaleida Ltd',
  microsoftAuthenticationRequiredRole: 'c04d9cb9-7d0c-4b18-8943-a16b7be86b46',
	microsoftAuthenticationUseForUsernamesContaining: '@ticketline.co.uk'
};
